import { colors, colors2, CONTENT_H1, styledOKELinkCSS, typoV2_CSS } from "oolib";
import styled, { css } from "styled-components";
import { codeThemeCSS } from "./themes/code";
import { tableThemeCSS } from "./themes/table";
import { annoThemeCSS } from "./themes/anno";

export const StyledEditorWrapperLex = styled.div`
  position: relative;
  

  color: ${({ color }) => color ? color : colors.greyColor100 };

  /*  h1, h2, h3, and blockquote */
  .contentEditableLex h1,
  .contentEditableLex h2,
  .contentEditableLex h3,
  .contentEditableLex blockquote {
    margin: 28px 0;
  }

  /* for first child h1, h2, h3, and blockquote */
  .contentEditableLex > h1:first-child,
  .contentEditableLex > h2:first-child,
  .contentEditableLex > h3:first-child,
  .contentEditableLex > blockquote:first-child {
    margin-top: 0;
    margin-bottom: 28px;
  }

  /* for h1, h2, h3, and blockquote followed by a paragraph */
  .contentEditableLex h1 + p,
  .contentEditableLex h2 + p,
  .contentEditableLex h3 + p{
    margin-top: -20px; /* 28px - 20px = 8px */
  }

  /* paragraph  */
  .contentEditableLex > p {
    margin-bottom: 8px;
  }

  .contentEditableLex > p:only-child {
    margin-bottom: 0;
  }

  .contentEditableLex {
    &:focus {
      outline: none;
    };
    ${({textAlignment}) => textAlignment && css` text-align: ${textAlignment}`};
  }
  .orderedListStyleLex,
  .unorderedListStyleLex {
    padding-left: 2rem;
  }

  .listItemStyleLex {
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
  }

  .orderedListStyleLex .listItemStyleLex {
    list-style: decimal;
  }

  .unorderedListStyleLex .listItemStyleLex {
    list-style: disc;
  }

  /* h4 / h5 are repurposed as label / sublabel styles via the heading
     theme map in LexicalTextEditor (h4 -> UI_BODY_SM_DF, h5 ->
     UI_CAPTION_DF). Typography is applied via those classes; colors
     must be set explicitly here to match BlockLabel. */
  .contentEditableLex h4 {
    color: ${colors2.grey80};
  }
  .contentEditableLex h5 {
    color: ${colors2.grey60};
  }

  .temp_bold {
    font-weight: 600; //600 is actually semibold
  }

  .temp_italic {
    font-style: italic;
  }

  .temp_underline {
    text-decoration: underline;
  }

  .OKELink {
    ${styledOKELinkCSS};
    display: inline; /* override inline-flex from styledOKELinkCSS; inline-flex breaks long text into vertical columns */
  }

  .OKELink::after {
    background-color: currentColor;
  }

  /** code styling */
  ${codeThemeCSS}

  ${tableThemeCSS}

  /** checkbox styling.
      ideally it should pull from the exact styling of CheckboxList on oolib
   */
  .temp_listItemCheckedStyleLex,
  .temp_listItemUncheckedStyleLex {
    position: relative;
    margin-left: 8px;
    margin-right: 8px;
    padding-left: 28px;
    padding-right: 24px;
    list-style-type: none !important;
    outline: none;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
  }
  .temp_listItemCheckedStyleLex {
    text-decoration: line-through;
  }
  .temp_listItemUncheckedStyleLex:before,
  .temp_listItemCheckedStyleLex:before {
    content: "";
    width: 2rem;
    height: 2rem;
    top: 2px;
    left: 0;
    cursor: pointer;
    display: block;
    background-size: cover;
    position: absolute;
  }
  .temp_listItemUncheckedStyleLex[dir="rtl"]:before,
  .temp_listItemCheckedStyleLex[dir="rtl"]:before {
    left: auto;
    right: 0;
  }
  /* .temp_listItemUncheckedStyleLex:focus:before,
  .temp_listItemCheckedStyleLex:focus:before {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme?.colors.primaryColor40};
    border-radius: 2px;
  } */
  .temp_listItemUncheckedStyleLex:before {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme?.colors.primaryColor100};
    border-radius: 2px;
  }
  .temp_listItemCheckedStyleLex:before {
    border: 1px solid ${({ theme }) => theme?.colors.primaryColor100};
    border-radius: 2px;
    background-color: ${({ theme }) => theme?.colors.primaryColor100};
    background-repeat: no-repeat;
  }
  .temp_listItemCheckedStyleLex:after {
    content: "";
    cursor: pointer;
    border-color: ${colors.white};
    border-style: solid;
    position: absolute;
    display: block;
    top: 4.5px;
    width: 7px;
    left: 6.5px;
    height: 12px;
    transform: rotate(45deg);
    border-width: 0 1.8px 1.8px 0;
    border-radius: 1.1px;
  }

  .PlaygroundEditorTheme__table h1,
  .PlaygroundEditorTheme__table h2,
  .PlaygroundEditorTheme__table h3 {
    margin: 0;
  }
  //anno temp
  ${annoThemeCSS}

  ${({ $v2 }) =>
    $v2 &&
    css`
      .contentEditableLex {
        ${typoV2_CSS.UI_BODY_SM_DF};
        line-height: 1.55;
        caret-color: ${colors2.grey80};
        color: ${colors2.grey80};
      }

      .contentEditableLex p {
        ${typoV2_CSS.UI_BODY_SM_DF};
        color: inherit;
        margin: 0;
        & span {
          line-height: 22px !important;
        }
      }
      .contentEditableLex p + p {
        margin-top: 1rem;
      }

      .contentEditableLex .temp_bold,
      .contentEditableLex strong {
        font-weight: 700 !important;
        line-height: 22px !important;
      }
      .contentEditableLex .temp_italic,
      .contentEditableLex em {
        font-style: italic !important;
        line-height: 22px !important;
      }
      .contentEditableLex .temp_underline {
        text-decoration: underline !important;
        line-height: 22px !important;
      }

      .contentEditableLex .orderedListStyleLex,
      .contentEditableLex .unorderedListStyleLex {
        padding-left: 2rem;
      }
      .contentEditableLex .listItemStyleLex {
        ${typoV2_CSS.UI_BODY_SM_DF};
        line-height: 22px !important;
        margin-top: 0.4rem;
        margin-bottom: 0.4rem;
      }
      .contentEditableLex .orderedListStyleLex .listItemStyleLex {
        list-style: decimal;
      }
      .contentEditableLex .unorderedListStyleLex .listItemStyleLex {
        list-style: disc;
      }

      .contentEditableLex h1 {
        ${typoV2_CSS.UI_DISPLAY_SM};
        line-height: 38px;
        color: inherit;
      }
      .contentEditableLex h2 {
        ${typoV2_CSS.UI_HEADLINE_SM};
        line-height: 33px;
        color: inherit;
      }
      .contentEditableLex h3 {
        ${typoV2_CSS.UI_TITLE};
        font-weight: 600;
        color: inherit;
      }
      .contentEditableLex > h1:first-child,
      .contentEditableLex > h2:first-child,
      .contentEditableLex > h3:first-child,
      .contentEditableLex > blockquote:first-child {
        margin-top: 0;
        margin-bottom: 28px;
      }

      /* A heading that is the editor's only content is a title, not a section
         opener: nothing follows it, so no gap below it. Sits after the
         first-child rule at equal specificity so it wins. */
      .contentEditableLex > h1:only-child,
      .contentEditableLex > h2:only-child,
      .contentEditableLex > h3:only-child {
        margin-bottom: 0;
      }

      .contentEditableLex h1:has(+ h1),
      .contentEditableLex h2:has(+ h2) {
        margin-bottom: 14px !important;
      }
      .contentEditableLex h1 + h1,
      .contentEditableLex h2 + h2 {
        margin-top: 14px !important;
      }

      .contentEditableLex h3:has(+ h3) {
        margin-bottom: 12px !important;
      }
      .contentEditableLex h3 + h3 {
        margin-top: 12px !important;
      }

      .contentEditableLex h1:not(:has(+ h1)),
      .contentEditableLex h2:not(:has(+ h2)),
      .contentEditableLex h3:not(:has(+ h3)) {
        margin-bottom: 28px;
      }

      .contentEditableLex h1 + p,
      .contentEditableLex h2 + p,
      .contentEditableLex h3 + p {
        margin-top: -10px;
      }

      .contentEditableLex blockquote {
        ${typoV2_CSS.CONTENT_QUOTE};
        ${typoV2_CSS.UI_BODY_SM_DF};
        font-size: 18px;
        line-height: 23px;
        font-weight: 500;
        font-style: italic;
        margin: 12px 0;
        color: inherit;
        background-color: #F0F6FF;
        padding: 9px 16px;
        ::before {
          width: 4px;
          background-color: #68A7FF;
        }
      }
    `}
`;

export const StyledPlaceholderLex = styled.p`
  color: ${({ theme, placeholderColor, invert }) => placeholderColor || (invert ? theme?.colors.primaryColor40 : theme?.colors.primaryColor100)};
  position: absolute;
  pointer-events: none;
  top: 0;
  width: 100%;
  ${({textAlignment}) => textAlignment && css` text-align: ${textAlignment}`};
`;
